import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=aac048aa&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=aac048aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac048aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aac048aa')) {
      api.createRecord('aac048aa', component.options)
    } else {
      api.reload('aac048aa', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=aac048aa&scoped=true&", function () {
      api.rerender('aac048aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YdCSMFMGpANv/JS/comp/PopupBox.vue"
export default component.exports